'use client'

import { useEffect } from 'react'

import ErrorPage from '@/components/error/ErrorPage'
import { reportErrorToNewRelic } from '@/utils/newrelic'

interface Props {
  error: Error
  reset: () => void
}

export default function Error({ error }: Props) {
  useEffect(() => {
    reportErrorToNewRelic(error, {
      errorBoundary: 'global',
      errorMessage: error.message,
      errorStack: error.stack,
      errorName: error.name
    })
  }, [error])

  return <ErrorPage error={error} />
}
